import { Fragment } from "react"
import { useRoutes } from "react-router-dom"
import Layout from "@/pages/dashboard/components/layout"
import Initialization from "@/middlewares/initialize"
import routes from "@/routes"
import { Toaster } from "@/components/ui/toaster"

function App() {
  const views = useRoutes(routes)

  return (
    <Fragment>
      <Layout>
        <Initialization>
          <div>{views}</div>
          <Toaster />
        </Initialization>
      </Layout>
    </Fragment>
  )
}

export default App
